/// <reference path="../../app.definition.ts" />
import { Serializable } from "./Serializable";
import { CurrentUsage } from "./billing_cycle";

export class Plan implements Serializable<Plan> {
    id: string;
    isActive: boolean;
    description: string;
    name: string;
    maxCR: number;
    maxConcurrentDownloads: number = 1;
    maxDiscussions: number;
    maxDocuments: number;
    maxUploadSize: number;
    maxGalleryPhotos: number;
    iconName: string;
    theme: string;
    planType: string;
    displayText: string;
    maxCombineDocuments: number;

    currentUsage = new CurrentUsage();

    deserialize(input: any) {
        input.id && (this.id = input.id);
        input.isActive && (this.isActive = input.isActive);
        input.description && (this.description = input.description);
        input.name && (this.name = input.name);
        !!input.iconName && (this.iconName = '/src/client/assets/images/svg/' + input.iconName);
        input.maxConcurrentDownloads && (this.maxConcurrentDownloads = input.maxConcurrentDownloads);
        input.maxCareTeams && (this.maxCR = input.maxCareTeams);
        input.maxDiscussions && (this.maxDiscussions = input.maxDiscussions);
        input.maxDocUploadSize && (this.maxUploadSize = input.maxDocUploadSize);
        input.maxDocuments && (this.maxDocuments = input.maxDocuments);
        input.maxGalleryPhotos && (this.maxGalleryPhotos = input.maxGalleryPhotos);
        input.planType && (this.planType = input.planType);
        input.displayText && (this.displayText = input.displayText);
        input.maxCombineDocuments && (this.maxCombineDocuments = input.maxCombineDocuments);

        if (input.iconName) {
            this.theme = input.iconName.substr(0, input.iconName.lastIndexOf('.'));
        }

        !!input.usersCurrentUsage && (this.currentUsage = new CurrentUsage().deserialize(input.usersCurrentUsage));


        return this;
    }

    constructor() {
    }
}

